export function contactSummary(state, action) {
  return state;
}
